import React, { lazy, Suspense } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy-loaded pages for code splitting
const LandingPage = lazy(() => import('./pages/LandingPage'));
const Authentication = lazy(() => import('./pages/authentication'));
const VideoMeetComponent = lazy(() => import('./pages/VideoMeet'));
const HomeComponent = lazy(() => import('./pages/home'));
const History = lazy(() => import('./pages/history'));

// Full-page loading fallback
const PageLoader = () => (
  <div
    role="status"
    aria-label="Loading"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'var(--bg-base)',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid var(--border-default)',
          borderTopColor: 'var(--brand-primary)',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          margin: '0 auto 16px',
        }}
      />
      <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Loading…</p>
    </div>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          {/* Global toast notifications */}
          <Toaster
            position="top-right"
            gutter={10}
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--bg-surface-2)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-default)',
                borderRadius: 'var(--radius-md)',
                fontSize: '14px',
                boxShadow: 'var(--shadow-md)',
                maxWidth: '380px',
              },
              success: {
                iconTheme: { primary: 'var(--success)', secondary: '#fff' },
              },
              error: {
                iconTheme: { primary: 'var(--error)', secondary: '#fff' },
              },
            }}
          />

          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/"        element={<LandingPage />} />
              <Route path="/auth"    element={<Authentication />} />
              <Route path="/home"    element={<HomeComponent />} />
              <Route path="/history" element={<History />} />
              <Route path="/:url"    element={<VideoMeetComponent />} />
            </Routes>
          </Suspense>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;